// extracted by mini-css-extract-plugin
export default {"espacamento":"Banner_espacamento__ylUqe","label":"Banner_label__2Qmm0","totalPagar":"Banner_totalPagar__6eKlV","formatacaoTextoPix":"Banner_formatacaoTextoPix__KK1P9"};